module.exports = __webpack_public_path__ + "img/argentina-logo-icon.57b35c24.png";